import { Output, EventEmitter, Component } from '@angular/core';
import { CardModel } from '@modules/card/models/card.model';

@Component({
  template: '',
})
export abstract class SectionDefaultsComponent {
  @Output() openMedia = new EventEmitter();

  openCardMedia(data: CardModel) {
    if (!data.link && data.media) {
      this.openMedia.emit(data.media);
    }
  }
}
